import styled from "styled-components";

import { colors } from "../../../../../assets";
import { SectionContainer } from "../../clients-dashboard-style";

export const RenewalPoliciesContainer = styled(SectionContainer)`
  table thead tr th {
    background-color: ${colors["msg-info"]};
    color: ${colors["TX-001-100"]};
  }

  .button-container {
    margin-top: 30px;
    position: relative;
  }
`;
